import { render } from "./DarkModeSwitcher.vue?vue&type=template&id=3f84226a"
import script from "./DarkModeSwitcher.vue?vue&type=script&lang=js"
export * from "./DarkModeSwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script